module.exports = __webpack_public_path__ + "img/top_banner2.d494cbb5.png";